var Accordeon = {
    init:function(){
        document.querySelectorAll(".accordeon-header").forEach(function(item, i){
            if(! item.classList.contains("initialized")) {
                item.classList.add("initialized");
                item.addEventListener("click", function(e){
                    Accordeon.changeItem(i);
                });
            }
        });
    },
    changeItem:function(id){
        document.querySelectorAll(".accordeon-item").forEach(function(item, i){
            if(i == id){
                if(item.classList.contains("open")){
                    item.classList.remove("open");
                    item.querySelector(".accordeon-content").style.height = 0;
                }else{
                    item.classList.add("open");
                    var _h_dest = item.querySelector(".accordeon-text").offsetHeight;
                    item.querySelector(".accordeon-content").style.height = _h_dest + "px";
                }
            }else{
                item.classList.remove("open");
                item.querySelector(".accordeon-content").style.height = 0;
            }
        });
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".accordeon-container").length > 0){
        Accordeon.init();
    }
})